import React, { Component } from 'react';
import ApiManager from '../../../apiManager';
import { trans, setBracketsAfterFirstPart, getFileNameExt, setCommaDateFormat } from '../../../helpers';
import config from '../../../baseConfig';
import Modal from '../../Fragments/Modal';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';

class B2bEditApplication extends Component {

    constructor( props ){
        super( props );

        this.state = {
            editId: '',
            editData: '',
            adminNote: '',
            formResponse: '',
            successModal: false,
            saveAdminNote: false
        };

        // Component props
        this.componentIsMounted = true;

        // Bind own methods
        this.getEditAppDataSuccess = this.getEditAppDataSuccess.bind( this );
        this.saveAdminNoteSuccess = this.saveAdminNoteSuccess.bind( this );

    }

    componentDidMount() {

        if ( this.props.pathname[1] === 'applicationEdit' && !isNaN( this.props.pathname[2] ) ) {

            this.setState({
                editId: this.props.pathname[2]
            });

            // Get application data
            ApiManager.getRequest({
                jwt: this.props.getDecryptedToken(),
                id: this.props.pathname[2]
            }, '/b2b' + this.props.curator + '/application/edit').then( this.getEditAppDataSuccess, this.props.errorCallBack );

        }

    }

    getEditAppDataSuccess({ data }){

        if ( !this.componentIsMounted ) {
            return;
        }

        const newState = {
            editData: data
        };

        if ( this.props.curator === '' ) {
            newState['adminNote'] = data.data.application.application_admin_comments || '';
        }

        this.setState( newState );

    }

    componentWillUnmount(){

        this.componentIsMounted = false;

    }

    drawCtns( editData ){

        const data = { cnts: '', cntsCount: 0 };

        if ( editData !== '' && editData.status === 'OK' ) {

            const applicationData = editData.data.application.ctn.split(',');
            const ctns = applicationData.map(( item, index ) => {
                return (
                    <li className="application-form__ctn-item application-form__ctn-item--readonly fs18 ver-top-box pr" key={index}>+374 {setBracketsAfterFirstPart(item.toString().replace(/^74/, ''))}</li>
                );
            });

            data.count = applicationData.length;
            data.ctns = <ul className="application-form__ctn-list scroller-block">{ctns}</ul>;

        }

        return data;

    }

    drawFileList( editData ){

        let files = '';

        if ( editData !== '' && editData.status === 'OK' && editData.data.application.application_files_content.length ) {

            files = editData.data.application.application_files_content.map(( { label, file_name }, index ) => {

                const { fileExt } = getFileNameExt(label);

                return (
                    <a className={`application-form__file-item application-form__file-item--${fileExt} fs18 monserrat-medium ver-top-box pr`}
                       href={file_name}
                       key={index}
                       download={true}
                    >{label}<span className="application-form__remove sprite pa"></span></a>
                );
            });

        }

        return files;

    }

    saveAdminNoteSuccess({ data }){

        if ( !this.componentIsMounted ) {
            return;
        }

        this.setState({
            formResponse: data,
            successModal: data.status === 'OK',
            saveAdminNote: false
        });

    }

    saveAdminNote( status ){

        this.setState({
            saveAdminNote: status
        });

        ApiManager.postRequest({
            _token: this.props.csrf_token.data,
            jwt: this.props.getDecryptedToken(),
            id: this.state.editId,
            application_status: status,
            application_admin_comments: this.state.adminNote
        }, '/b2b/application/save').then( this.saveAdminNoteSuccess, this.errorCallBack );

    }

    editAppSuccessModal(){

        if ( !this.state.successModal ) {
            return null;
        }

        return (
            <Modal
                title={trans(this.props.b2bTrans, 'b2b.edit_application.success_modal.title')}
                description={trans(this.props.b2bTrans, 'b2b.edit_application.success_modal.description')}
                agreeText={trans(this.props.b2bTrans, 'b2b.edit_application.success_modal.agree')}
                agreeAction={() => {
                    this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/applications' );
                    this.props.updatePath();
                }}
                className="modal--full"
            />
        );

    }

    render(){

        const { formResponse } = this.state;

        let commentsErrorClass = '',
            commentsErrorBox = '',
            errorBox = '';

        if ( formResponse !== '' && formResponse.status === 'INVALID_DATA' ) {

            if ( formResponse.errors.hasOwnProperty('application_admin_comments') ) {

                commentsErrorClass = ' form-error';
                commentsErrorBox = <div className="form-error-text fs11">{formResponse.errors.application_admin_comments}</div>;

            }

        }

        if ( formResponse !== '' && formResponse.status === 'ERROR' ) {

            errorBox = (
                <div>
                    <div className="ver-top-box">
                        <FormMiddlewareError message={formResponse.code} />
                    </div>
                </div>
            );

        }

        const { editData } = this.state;
        let number = '',
            date = '',
            inn = '',
            ban = '',
            priority = '',
            comments = '',
            email = '',
            fullName = '',
            curatorAdminNote = '',
            status = '',
            applicationType = '',
            changeTP = '';

        if ( editData !== '' && editData.status === 'OK' ) {
            number = editData.data.application.id;
            status = trans( this.props.b2bTrans, 'b2b.application.status_' + editData.data.application.application_status );
            date = setCommaDateFormat( editData.data.application.updated_at );
            inn = editData.data.application.inn;
            ban = editData.data.application.ban;
            applicationType = editData.data.application.application_type && editData.data.application.application_type.current.title;
            changeTP = editData.data.application.tariff && editData.data.application.tariff.current.name;
            priority = trans( this.props.b2bTrans, 'b2b.application.priority_' + editData.data.application.application_priority );
            comments = (
                <textarea
                    className="application-form__textarea"
                    name="application-comments"
                    id="application-comments"
                    cols="30"
                    rows="10"
                    disabled={true}
                    defaultValue={editData.data.application.application_curator_comments}
                />
            );
            email = editData.data.application.email;
            fullName = editData.data.application.creator.first_name + ' ' + editData.data.application.creator.last_name;

            curatorAdminNote = (
                <textarea
                    className="application-form__textarea"
                    name="application-note"
                    id="application-note"
                    cols="30"
                    rows="10"
                    defaultValue={editData.data.application.application_admin_comments}
                    disabled={true}
                />
            );

        }

        return (
            <div className="main-wrapper__right-inner scroller-block pr">

                <div className="main-wrapper__right-content">

                    <h2 className="main-wrapper__title main-wrapper__title--with-border fb fs20">{trans( this.props.b2bTrans, 'b2b.edit_app.title' )}</h2>

                    <form className="application-form application-form--big" action="#" method="post" onSubmit={( event ) => {
                        event.preventDefault();
                        this.saveAdminNote( 0 );
                    }}>
                        <div className="application-form__box application-form__box--with-border clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.number_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number monserrat-medium fs18">{number}</p>
                            </div>
                        </div>
                        <div className="application-form__box application-form__box--with-border clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.date_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number monserrat-medium fs18">{date}</p>
                            </div>
                        </div>
                        <div className="application-form__box application-form__box--with-border clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.creator_name_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number monserrat-medium fs18">{fullName}</p>
                            </div>
                        </div>
                        <div className="application-form__box application-form__box--with-border clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.creator_email_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number monserrat-medium fs18">{email}</p>
                            </div>
                        </div>
                        <div className="application-form__box application-form__box--with-border clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.creator_inn_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number monserrat-medium fs18">{inn}</p>
                            </div>
                        </div>
                        <div className="application-form__box application-form__box--with-border clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.creator_ban_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number monserrat-medium fs18">{ban}</p>
                            </div>
                        </div>

                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.ctn_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <p className="application-form__number application-form__number--bottom-space monserrat-medium fs18">
                                    <b>{this.drawCtns( editData )['count']}</b> {trans( this.props.b2bTrans, 'b2b.edit_app.number_selected' )}
                                </p>
                                <div className="application-form__ctn-box ver-top-box">{this.drawCtns( editData )['ctns']}</div>
                            </div>
                        </div>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.type_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                {
                                    applicationType ?
                                        <div className="application-form__select-box ver-top-box">
                                            <p className="fs18 monserrat-medium">{applicationType}</p>
                                        </div> : null
                                }

                                {
                                    changeTP ?
                                        <div className="application-form__select-box ver-top-box">
                                            <span className="application-form__tariff fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.new_tp_title' )}</span>
                                            <p className="fs18 monserrat-medium ver-top-box">{changeTP}</p>
                                        </div> : null
                                }
                            </div>
                        </div>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <p className="application-form__label application-form__label-box--top-padding fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.priority_label' )}</p>
                            </div>
                            <div className="application-form__right-box">
                                <div className="application-form__select-box ver-top-box">
                                    <div className="application-form__priority monserrat-medium fs18 ver-top-box">{priority}</div>
                                </div>
                            </div>
                        </div>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <label htmlFor="application-comments" className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.comments_label' )}</label>
                            </div>
                            <div className="application-form__right-box">{comments}</div>
                        </div>
                        {
                            this.drawFileList( editData ) !== ''
                                ? <div className="application-form__box application-form__box--bottom-space clear-fix">
                                    <div className="application-form__label-box fl">
                                        <p className="application-form__label application-form__label-box--top-padding fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.attach_file_label' )}</p>
                                    </div>
                                    <div className="application-form__right-box">{this.drawFileList( editData )}</div>
                                </div> : ''
                        }
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <label htmlFor="application-note" className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.admin_note_label' )}</label>
                            </div>
                            <div className={`application-form__right-box${commentsErrorClass}`}>
                                {
                                    this.props.curator === 'curator'
                                        ? curatorAdminNote
                                        : <textarea
                                            className="application-form__textarea"
                                            name="application-note"
                                            id="application-note"
                                            cols="30"
                                            rows="10"
                                            value={this.state.adminNote}
                                            onChange={({ target: { value } }) => this.setState({ adminNote: value })}
                                        />
                                }
                                {commentsErrorBox}
                                {errorBox}
                            </div>
                        </div>
                        <div className="application-form__box clear-fix">
                            <div className="application-form__label-box fl">
                                <label htmlFor="application-note" className="application-form__label fs14">{trans( this.props.b2bTrans, 'b2b.edit_app.status' )}</label>
                            </div>
                            <div className="application-form__right-box">{status}</div>
                        </div>
                        <div className="application-form__box clear-fix mb-none">
                            <div className="application-form__label-box fl">&nbsp;</div>
                            <div className="application-form__right-box">
                                {
                                    this.props.curator !== 'curator'
                                        ? <>
                                            <button
                                                className={`application-form__action-btn btn btn--yellow monserrat-medium fs18 ver-top-box${this.state.saveAdminNote === 0 ? ' btn--loading' : ''}`}
                                                type="submit"
                                                disabled={this.state.saveAdminNote === 0}
                                            >{trans( this.props.b2bTrans, 'b2b.edit_app.done_title' )}</button>
                                            <button
                                                className={`application-form__action-btn btn btn--white monserrat-medium fs18 ver-top-box${this.state.saveAdminNote === 1 ? ' btn--loading' : ''}`}
                                                type="button"
                                                onClick={() => this.saveAdminNote( 1 )}
                                                disabled={this.state.saveAdminNote === 1}
                                            >{trans( this.props.b2bTrans, 'b2b.edit_app.deny_title' )}</button>
                                          </> : ''
                                }
                                <button
                                    className="application-form__action-btn application-form__action-btn--back btn btn--white sprite-b monserrat-medium fs18 ver-top-box pr"
                                    type="button"
                                    onClick={() => {
                                        this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/applications' );
                                        this.props.updatePath();
                                    }}
                                >{trans( this.props.b2bTrans, 'b2b.edit_app.back_title' )}</button>
                            </div>
                        </div>
                    </form>

                </div>

                {this.editAppSuccessModal()}

            </div>
        );

    }

}

export default B2bEditApplication;